<template>
	<div>
    <div class="vx-row">
<!-- 
      <CardCongratz class="w-full sm:w-12/12 md:w-2/2 lg:w-4/4 xl:w-4/4 mb-base"></CardCongratz>

      <CardOrderByPeriod class="vx-col w-full md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"></CardOrderByPeriod>

      <CardUserByPeriod class="vx-col w-full md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"></CardUserByPeriod>

      <CardUserInOut class="vx-col w-full sm:w-3/3 md:w-4/4 lg:w-3/3 xl:w-1/3 mb-base"></CardUserInOut>

      <CardRealtimeOrders class="vx-col w-full sm:w-3/3 md:w-4/4 lg:w-3/3 xl:w-2/3 mb-base"></CardRealtimeOrders> -->
    </div>

  </div>
</template>

<script>
  // import CardUserByPeriod from '@/components/cards/userByPeriod'
  // import CardOrderByPeriod from '@/components/cards/orderByPeriod'
  // import CardCongratz from '@/components/cards/congratz'
  // import CardUserInOut from '@/components/cards/userInOut'
  // import CardRealtimeOrders from '@/components/cards/realtimeOrders'

  export default {
    // components : {
    //   CardUserByPeriod,
    //   CardOrderByPeriod,
    //   CardCongratz,
    //   CardUserInOut,
    //   CardRealtimeOrders
    // },
    created () {
      this.$vs.theme({ primary: "#EA5455" });
    }
  }
</script>

<style>
</style>